import React from 'react';
import PropTypes from 'prop-types';
import ReadMore from 'components/ReadMore';
import './styles.css';

const InfoListItem = props => {
  const setValue = () => {
    if (props.href) {
      return (
        <a
          className="info-list__item-link"
          href={props.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {props.value}
        </a>
      );
    }

    if (typeof props.value === 'string') {
      return props.value.length > 150 ? (
        <ReadMore
          text={props.value}
          readMoreCharacterLimit={150}
          numberOfLines={1}
        />
      ) : (
        props.value
      );
    }

    if (typeof props.value === 'object') {
      return props.value.map((link, i) => {
        return (
          <div key={i}>
            {link.href ? (
              <a
                className="info-list__item-link"
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.text}
              </a>
            ) : (
              <span>{link.text}</span>
            )}
          </div>
        );
      });
    }
  };

  return (
    <li className="info-list__item" key={props.index} style={props.styles}>
      <div className="info-list__item-question">{props.name}</div>
      <div className="info-list__item-answer">{setValue()}</div>
    </li>
  );
};

InfoListItem.propTypes = {
  styles: PropTypes.object,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default InfoListItem;
